import { Component, OnInit, ViewChild } from '@angular/core';
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import { SessionService } from 'app/sessions/session.service';
import { DateService } from 'app/date/date.service';
import { HRMSService } from '../shared/hrms.service';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { UtilService } from '../shared/util.service';
import { UserService } from 'app/users/shared/user.service';
import { IOption } from 'ng-select';
import { SettingsService } from 'app/settings/settings.service';

@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.css'],
  animations: [fadeInOutTranslate]
})
export class AttendanceComponent implements OnInit {
  isUserClockedIn:boolean = false;
  date:Date;
  totalHours:any;
  gridView:GridDataResult;
  public skip1 = 0;
  public pageSize = 10;
  public skip2 = 0;
  attendanceList:any;
  employeesOptions:Array<IOption>;
  holidays:any[];
  employeeLeaveList:any[];
  lastTimeInMilliSecond:number;
  avgWorkingHoursFor6Days:any = 0;
  onTimeArrivalCount:any=0;
  @ViewChild("reminderModal") reminderModal;
  previousDayLogKey:any;
  setting:any;
  constructor(private ss:SessionService, private dateService:DateService, private hrmsService: HRMSService, private util:UtilService, private userService:UserService, private settingService:SettingsService) { }

  ngOnInit() {
    this.getClockInOutInfo();
    this.date = new Date();
    var date1 = new Date("2019-05-18 4:0 AM");
    var date2 = new Date("2019-05-18 6:0 PM");
    var diff = Math.abs(date1.getTime() - date2.getTime()) / 3600000;
    this.getSettings();
    this.getPreviousDaysClockOutData();
    this.getAllEmployeesLeaves();
    this.getTotalHours();
    this.getNumberOfDays();
    this.getAllEmployees();
    this.getAllHolidays();
    this.getDashboardData();
    setInterval(() => {
      if(this.isUserClockedIn)
      {
        //console.log("setinterval",this.lastTimeInMilliSecond+1000);
        this.lastTimeInMilliSecond = this.lastTimeInMilliSecond+1000;
        this.totalHours = this.msToTime(this.lastTimeInMilliSecond);
      }
    },1000);

    
    
    
if (diff < 18) { /* do something */ }
  }
  getPreviousDaysClockOutData()
  {
    this.hrmsService.getPreviousDaysClockOutData().once("value").then((data)=>{
      //console.log("data here",data.val());
      data.forEach(d=>{
        //console.log("d",d.val());
        if(!d.child("clockOut").exists() || d.child("clockOut").val()  == "")
        {
          if(d.child("clockIn").val() != "")
          {
            this.dateService.getDayDifference(new Date(this.dateService.getTodaysDate()),new Date(data.key));
            //console.log("daydif",data.key,this.dateService.getDayDifference(new Date(this.dateService.getTodaysDate()),new Date(data.key)));
            //alert("you have not been clocked out");
            this.reminderModal.show();
            this.previousDayLogKey = d.key;
          }
        }
      });
    });
  }
  clockOutPreviousDay()
  {
    var data = {
      clockOut:this.dateService.getTimeandDate().time
  };
    this.hrmsService.updatePReviousDatClockout(this.previousDayLogKey,data).then(()=>{
      this.reminderModal.hide();
    });
  }
  onClickClockIn()
  {
    this.hrmsService.getLastClockInfo().once("value").then((data)=>{
      data.forEach(d=>{
        if(d.child("clockIn").val() == "")
        {
          this.hrmsService.clockIn(d.key).then(()=>{
          });
        }
        else
        {
          this.hrmsService.clockIn(null).then(()=>{
          });
        }
      });
    });
  }
  onClickClockOut()
  {
    this.hrmsService.getLastClockInOut(this.ss.getEmployeeId,"today").once("value").then((data)=>{
      data.forEach(element => {
        var data = {
          clockOut:this.dateService.getTimeandDate().time,
          updatedAt: this.dateService.getTimeandDate().timeStamp
      };
      this.hrmsService.clockOut(element.key,data).then(()=>{
        this.hrmsService.changeAttendanceStatus(this.ss.getEmployeeId,this.util.getDateSearchForm(new Date(this.dateService.getTodaysDate())),"pending");
        if(this.setting == "manual")
        {
          this.hrmsService.sendAttendanceNotif(this.ss.getEmployeeId,this.util.getDateSearchForm(new Date(this.dateService.getTodaysDate())),"pending","unread");
        }
      });
      });
    });
  }
  getClockInOutInfo()
  {
    this.hrmsService.getLastClockInOutInfo().snapshotChanges().subscribe((data)=>{
      this.isUserClockedIn = false;
      data.forEach(element => {
          if(element.payload.child("clockOut").exists() && element.payload.child("clockOut").val() =="" && element.payload.child("clockIn").val() !="")
          {
            this.isUserClockedIn = true;
          }
          else if(!element.payload.child("clockOut").exists() && element.payload.child("clockIn").val() !="")
          {
            this.isUserClockedIn = true;
          }
      });
    });
  }
  getTotalHours()
  {
    this.hrmsService.getMyTodaysAttendance(this.ss.getEmployeeId).snapshotChanges().subscribe((data)=>{
      var hours=0;
      data.forEach(element=>{
        this.lastTimeInMilliSecond = hours;
        if(element.payload.child("clockOut").exists() && element.payload.child("clockOut").val() !="")
        {
          var date1 = new Date(this.dateService.getDate(this.date)+" "+element.payload.child("clockIn").val());
          var date2 = new Date(this.dateService.getDate(this.date)+" "+element.payload.child("clockOut").val());
          hours = hours + this.getDiff(date1,date2);
          this.lastTimeInMilliSecond = hours;
        }
        else if(element.payload.child("clockIn").val() !="")
        {
          var date1 = new Date(this.dateService.getDate(this.date)+" "+element.payload.child("clockIn").val());
          var date2 = new Date(this.dateService.getDate(this.date)+" "+this.dateService.getTimeandDate().time);
          hours = hours + this.getDiff(date1,date2);
          this.lastTimeInMilliSecond = hours;
        }
      });
      //this.totalHours = Number(hours).toFixed(2);
      this.totalHours = this.msToTime(hours);
    });
  }
  msToTime(duration) {
  var milliseconds = parseInt(String((duration % 1000) / 100));
  var seconds = Math.floor((duration / 1000) % 60);
  var minutes = Math.floor((duration / (1000 * 60)) % 60);
  var hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
  return (((hours < 10) ? "0" + hours : hours) + ":" + ((minutes < 10) ? "0" + minutes : minutes) + ":" + ((seconds < 10) ? "0" + seconds : seconds) + "." + milliseconds);
}

  getDiff(date1,date2)
  {
    //var diff = Math.abs(date1.getTime() - date2.getTime()) / 3600000;
    var diff = Math.abs(date1.getTime() - date2.getTime());
    return diff;
  }
  getNumberOfDays()
  {
    this.util.daysInMonth(this.date.getFullYear(),this.date.getMonth()+1);
  }

  getAllEmployees()
  {
    this.userService.getAllUser().snapshotChanges().subscribe((data)=>{
      this.employeesOptions = [];
      this.employeeLeaveList = [];
      //this.employeesOptions.push({label: "All", value: "All"});
      data.forEach((user)=>{
        if(user.payload.child("role").val() != 'customer')
        {
          var u = user.payload.val();
          this.employeesOptions.push({label: String(u.name), value: String(u.employeeId)});
          this.hrmsService.getEmployeeLeavesById(user.key).once("value").then((leaves)=>{
            this.employeeLeaveList[user.key] = leaves.val();
          });
        }
      });
  });
}
getAllHolidays()
{
 this.hrmsService.getAllHolidays().snapshotChanges().subscribe((holidayData)=>{
   this.holidays = [];
    holidayData.forEach((holidayElement)=>{
      var y = holidayElement.payload.toJSON();
      y["key"] = holidayElement.key;
      this.holidays[holidayElement.payload.child("date").val()] = y;
    });
  });
}
getAllEmployeesLeaves()
{
  this.employeeLeaveList = [];
  this.userService.getAllUser().snapshotChanges().subscribe((data)=>{
    data.forEach((user)=>{
      if(user.payload.child("role").val() != 'customer')
      {
          this.hrmsService.getEmployeeLeavesById(user.key).once("value").then((leaves)=>{
            this.employeeLeaveList[user.key] = leaves.val();
          });
      }
    });
    });
}
getDashboardData(){
  var date = new Date(this.dateService.getTodaysDate()), y = date.getFullYear(), m = date.getMonth();
    var firstDay = new Date(y, m, date.getDate());
    var lastDay = new Date(y, m, date.getDate() - 6);
    //console.log("date1,date2",firstDay,lastDay);
    this.hrmsService.getAttendance(this.ss.getEmployeeId,new Date(lastDay).getTime(),new Date(firstDay).getTime()).snapshotChanges().subscribe((data)=>{
      var hours= 0;
      this.onTimeArrivalCount = 0;
      data.forEach(date=>{
          var attendanceData = date.payload.child("logs").val();
          var ac = false;
          for(let i in attendanceData)
          {
            //console.log("attendanceData",attendanceData[i]);
              if(attendanceData[i].clockOut!= null && attendanceData[i].clockOut!= "")
              {
                var date1 = new Date(date.key+" "+attendanceData[i].clockIn);
                var date2 = new Date(date.key+" "+attendanceData[i].clockOut);
                hours = hours + this.util.getDiff(date1,date2);
                //console.log("hours",date.key , hours);
                this.avgWorkingHoursFor6Days = this.util.msToTime((hours / 6));
                //console.log("avgWorkingHoursFor6Days",this.avgWorkingHoursFor6Days);
              }
              if(attendanceData[i].clockIn!= null && attendanceData[i].clockIn!= "" && !ac)
              {
                ac = true;
                //console.log("this.onTimeArrivalCount",this.onTimeArrivalCount);
                
                var time1 = new Date(date.key+" 9:0 AM").getTime();
                var time2 = new Date(date.key+" "+attendanceData[i].clockIn).getTime();
                //console.log("time diff ",time2 - time1);
                if((time2 - time1) <= 300000)
                {
                  this.onTimeArrivalCount++;
                }
                //this.onTimeArrivalCount = this.onTimeArrivalCount / (Object.keys(attendanceData).length - 1);
                //this.onTimeArrivalCount = attendanceData[i].clockIn == "9:0 AM" || attendanceData[i].clockIn == "9:00 AM"?(this.onTimeArrivalCount+1):this.onTimeArrivalCount;
                //console.log("time",time1,time2,this.onTimeArrivalCount, time2-time1);
              }
              //this.onTimeArrivalCount = this.onTimeArrivalCount / ac;
          }
    });
  });
}
getSettings()
{
  this.settingService.getAttendanceSettings().on("value",(data)=>{
    this.setting = data.val();
  });
}
}




// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/attendance/attendance.component.ts